import { InfoMessage, Link, LinkProps } from 'ia-react-core';
import { AnchorHTMLAttributes, FC } from 'react';
import styled from 'styled-components';

export const StyledLink = styled<FC<LinkProps & AnchorHTMLAttributes<HTMLAnchorElement>>>(Link)`
  text-decoration: underline;

  &:hover {
    text-decoration: inherit;
  }
  &:active {
    text-decoration: inherit;
  }
`;

export const StyledInfoMessage = styled(InfoMessage)`
  margin-top: 39px;
`;

export const StyledSpan = styled.span`
  line-height: 1.29;
  font-weight: 600;
`;

export const StyledList = styled.div`
  margin-top: -24px;
`;
